// extracted by mini-css-extract-plugin
export default {"fullHeightContainer":"HomePageSeedComponent_fullHeightContainer__7EvUv","flexRow":"HomePageSeedComponent_flexRow__QzVRG","staticRow":"HomePageSeedComponent_staticRow__GnF68"};